import { DELETE, GET } from '../request'

export const getListFromProfesor = ({ profesor, mes }) =>
  GET('/api/core/planificacion/clase-profesor/list/profesor', { profesor, mes })

export const getListFromCentro = ({ centro, mes }) =>
  GET('/api/core/planificacion/clase-profesor/list/centro', { centro, mes })

export const deleteFromIds = ({ ids }) =>
  DELETE('/api/core/planificacion/clase-profesor/multiple', { 'ids[]': ids })
